import { render, staticRenderFns } from "./Refunds.vue?vue&type=template&id=a772c6a4"
import script from "./Refunds.vue?vue&type=script&lang=js"
export * from "./Refunds.vue?vue&type=script&lang=js"
import style0 from "./Refunds.vue?vue&type=style&index=0&id=a772c6a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports